import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\UpdatePlaceEnaosIdController::__invoke
* @see app/Http/Controllers/WikiPlace/UpdatePlaceEnaosIdController.php
* @route '/api/place/{wiki_place}/enaos'
*/
const UpdatePlaceEnaosIdController = (args: { wiki_place: string | { id: string } } | [wiki_place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePlaceEnaosIdController.url(args, options),
    method: 'put',
})

UpdatePlaceEnaosIdController.definition = {
    methods: ["put"],
    url: '/api/place/{wiki_place}/enaos',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\WikiPlace\UpdatePlaceEnaosIdController::__invoke
* @see app/Http/Controllers/WikiPlace/UpdatePlaceEnaosIdController.php
* @route '/api/place/{wiki_place}/enaos'
*/
UpdatePlaceEnaosIdController.url = (args: { wiki_place: string | { id: string } } | [wiki_place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_place: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { wiki_place: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_place: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_place: typeof args.wiki_place === 'object'
        ? args.wiki_place.id
        : args.wiki_place,
    }

    return UpdatePlaceEnaosIdController.definition.url
            .replace('{wiki_place}', parsedArgs.wiki_place.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\UpdatePlaceEnaosIdController::__invoke
* @see app/Http/Controllers/WikiPlace/UpdatePlaceEnaosIdController.php
* @route '/api/place/{wiki_place}/enaos'
*/
UpdatePlaceEnaosIdController.put = (args: { wiki_place: string | { id: string } } | [wiki_place: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePlaceEnaosIdController.url(args, options),
    method: 'put',
})

export default UpdatePlaceEnaosIdController